import React from "react"
import { IconWrapper } from "../IconWrapper"
import {
  BodySubtextMedium,
  BodySubtextMiniMedium,
  BodyTextMedium,
} from "../typography/text"

interface BadgeProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  icon?: React.ReactNode
  isRound?: boolean
  badgeSize?: "small" | "medium" | "large"
}

export const Badge = ({
  icon,
  children,
  isRound,
  className,
  badgeSize = "large",
  ...rest
}: BadgeProps) => {
  const TextComponent =
    badgeSize === "large"
      ? BodyTextMedium
      : badgeSize === "medium"
        ? BodySubtextMedium
        : BodySubtextMiniMedium

  return (
    <div
      className={`flex px-2 ${
        isRound ? "rounded-full" : "rounded-md"
      } flex-row gap-2 items-center min-w-fit w-fit ${
        className ? className : ""
      }`}
      {...rest}
    >
      {icon && <IconWrapper size={badgeSize}>{icon}</IconWrapper>}
      <TextComponent
        lineHeight={
          badgeSize === "large"
            ? "24px"
            : badgeSize === "medium"
              ? "20px"
              : "17px"
        }
      >
        {children}
      </TextComponent>
    </div>
  )
}
